import React, { useState, useRef, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Container, Row, Col, Form, Button, Card } from "react-bootstrap";
import { FaShieldAlt, FaUsers, FaLock, FaStar, FaPlay } from "react-icons/fa";
import HeaderNavbar from "../Component/Navbar";
import Footer from "../Component/Footer";
import { useNavigate } from "react-router-dom";
import RouteLoader from "./Routerloader";
import aboutimg from "../assets/aboutimg2.png";
import bride2 from "../assets/bride2.jpg";
import testimonial from "../assets/testimonial.jpeg";
import { MdOutlineRemoveRedEye } from "react-icons/md";
import { IoMdHeartEmpty } from "react-icons/io";
import { BsGeoAlt } from "react-icons/bs";
import { GoMortarBoard } from "react-icons/go";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Autoplay } from "swiper/modules";
import "swiper/css";
import couple from "../assets/couple.jpg";
import { getSubCaste } from "../store/slices/profile";
import { Modal } from "react-bootstrap";
import { IoClose } from "react-icons/io5";
import earlybirdOffer from "../assets/earlybird.png";


import "swiper/css";

import p1 from "../assets/p1.jpg";
import p2 from "../assets/p2.jpg";
import p3 from "../assets/p3.jpg";
import p4 from "../assets/p4.jpg";



export default function Home() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [showOfferModal, setShowOfferModal] = useState(false);

  useEffect(() => {
    const hasSeenOffer = sessionStorage.getItem("kvl_offer_shown");

    if (!hasSeenOffer) {
      const timer = setTimeout(() => {
        setShowOfferModal(true);
        sessionStorage.setItem("kvl_offer_shown", "true");
      }, 800); // small delay so it doesn't flash instantly on load

      return () => clearTimeout(timer);
    }
  }, []);

  const { subcaste = [] } = useSelector((state) => state.profile);

  const [searchText, setSearchText] = useState("");
  useEffect(() => {
    if (searchText.trim().length < 2) return;

    const timer = setTimeout(() => {
      dispatch(
        getSubCaste({
          search: searchText,
        })
      );
    }, 300);

    return () => clearTimeout(timer);
  }, [searchText, dispatch]);
  const [form, setForm] = useState({
    gender: "",
    age: "",
    subcaste: "",
    motherTongue: "",
  });

  const [errors, setErrors] = useState({});

  const validate = (name, value) => {
    let error = "";

    if (name === "gender") {
      if (!value) error = "Please select gender";
    }

    if (name === "age") {
      if (!value) error = "Please select age";
    }

    if (name === "subcaste") {
      if (!value.trim()) error = "Please enter subcaste";
      else if (/[0-9]/.test(value)) error = "Numbers not accept";
      else if (value.length > 30) error = "Max 30 characters only";
    }

    if (name === "motherTongue") {
      if (!value.trim()) error = "Please enter mother tongue";
      else if (/[0-9]/.test(value)) error = "Numbers not allowed";
      else if (value.length > 30) error = "Max 30 characters only";
    }

    return error;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (name === "subcaste") {
      setSearchText(value);
    }

    const error = validate(name, value);

    setErrors((prev) => ({
      ...prev,
      [name]: error,
    }));
  };

  const handleSearch = (e) => {
    e.preventDefault();

    let newErrors = {};
    Object.keys(form).forEach((key) => {
      const error = validate(key, form[key]);
      if (error) newErrors[key] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) return;

    navigate("/search-profile");
  };

  const videoRef = useRef(null);
  const [isPlaying, setIsPlaying] = useState(false);

  const playVideo = () => {
    videoRef.current.play();
    setIsPlaying(true);
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  const profiles = [
    {
      id: 1,
      name: "Priya Patil",
      age: 27,
      location: "Mumbai, Maharashtra",
      education: "MBA. IIM Bangalore",
      job: "Marketing Manager",
      image: p1,
    },
    {
      id: 2,
      name: "Rahul S.",
      age: 27,
      location: "USA",
      education: "B.Tech. IIT Delhi",
      job: "AI Engineer",
      image: p2,
    },
    {
      id: 3,
      name: "Pari P.",
      age: 27,
      location: "Pune, Maharashtra",
      education: "MCA. Bangalore University",
      job: "Software Engineer",
      image: p3,
    },
    {
      id: 4,
      name: "Soham S.",
      age: 27,
      location: "Chennai, Tamilnadu",
      education: "BE. IIT Bombay",
      job: "Mechanical Engineer",
      image: p4,
    },
    {
      id: 5,
      name: "Sonam K.",
      age: 27,
      location: "Dubai, UAE",
      education: "BE. IIT Hyderabad",
      job: "Data Scientist",
      image: p1,
    },
  ];

  const testimonials = [
    {
      name: "Riya & Aditya",
      place: "Hubli to Bangalore",
      text: "KVL Matrimony made our journey so easy! We found each other through their AI recommendations and it was love at first chat. The verification process made us feel safe and confident. Forever grateful!",

      image: couple,
    },
    {
      name: "Gangadhar & Sukanya",
      place: "Belgaum to Gadag",
      text: "We connected instantly through KVL Matrimony and everything felt so natural. The platform helped us find the perfect partner.",
      image: testimonial,
    },
  ];

  return (
    <>
      <RouteLoader>

        <div
          className="home-section  d-flex flex-column justify-content-between"
          style={{
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        >
          <HeaderNavbar isHome />
          <Container
            fluid
            className="site-container flex-grow-1 d-flex align-items-center justify-content-center"
          >
            <Row className="w-100 my-2 mx-2">
              <Col xxl={5}
                xl={6}
                lg={7}
                md={8} className="text-white">
                <div className="homeFormCard my-5">
                  <h2 className="formTitle">Find Your Perfect Match</h2>

                  <p className="formSubtitle">
                    Smart matchmaking with real profiles, verified identities.
                  </p>

                  <div className="formCard">
                    <h6 className="formHeading">Quick Match Search</h6>
                    <Form onSubmit={handleSearch}>
                      <Row className="g-3">
                        <Col xs={12} md={6} xl={6}>
                          <Form.Label className="formLabel">Gender</Form.Label>

                          <Form.Select
                            name="gender"
                            value={form.gender}
                            onChange={handleChange}
                            className="formInput"
                          >
                            <option value="" disabled hidden>
                              I am looking for
                            </option>
                            <option value="Bride">Bride</option>
                            <option value="Groom">Groom</option>
                          </Form.Select>

                          {errors.gender && (
                            <small style={{ color: "red" }}>
                              {errors.gender}
                            </small>
                          )}
                        </Col>

                        <Col xs={12} md={6} xl={6}>
                          <Form.Label className="formLabel">Age</Form.Label>

                          <Form.Select
                            name="age"
                            value={form.age}
                            onChange={handleChange}
                            className="formInput"
                          >
                            <option value="" disabled hidden>
                              Age
                            </option>
                            <option value="18-23">18-23</option>
                            <option value="24-29">24-29</option>
                            <option value="30-34">30-34</option>
                            <option value="35-39">35-39</option>
                            <option value="40-44">40-44</option>
                            <option value="45-49">45-49</option>
                            <option value="50+">More than 50</option>
                          </Form.Select>
                          {errors.age && (
                            <small style={{ color: "red" }}>{errors.age}</small>
                          )}
                        </Col>

                        <Col xs={12} md={6} xl={6}>
                          <Form.Label className="formLabel">
                            Subcaste
                          </Form.Label>

                          <div style={{ position: "relative" }}>
                            <Form.Control
                              name="subcaste"
                              value={form.subcaste}
                              onChange={handleChange}
                              placeholder="Search Subcaste"
                              className="formInput"
                              autoComplete="off"
                              maxLength={30}
                            />

                            {searchText.trim().length >= 2 && subcaste.length > 0 && (
                              <div className="ep-autocomplete">
                                {subcaste.map((item) => (
                                  <div
                                    key={item._id}
                                    className="ep-autocomplete-item" style={{ color: "#000" }}
                                    onClick={() => {
                                      setForm((prev) => ({
                                        ...prev,
                                        subcaste: item.name,
                                      }));

                                      setSearchText(""); // Close suggestions

                                      setErrors((prev) => ({
                                        ...prev,
                                        subcaste: "",
                                      }));
                                    }}
                                  >
                                    {item.name}
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>

                          {errors.subcaste && (
                            <small style={{ color: "red" }}>
                              {errors.subcaste}
                            </small>
                          )}
                        </Col>

                        <Col xs={12} md={6} xl={6}>
                          <Form.Label className="formLabel">
                            Mother Tongue
                          </Form.Label>

                          <Form.Control
                            name="motherTongue"
                            value={form.motherTongue}
                            onChange={handleChange}
                            placeholder="Mother tongue"
                            className="formInput"
                            maxLength={30}
                          />

                          {errors.motherTongue && (
                            <small style={{ color: "red" }}>
                              {errors.motherTongue}
                            </small>
                          )}
                        </Col>
                      </Row>

                      <div className="d-flex justify-content-center align-items-center">
                        <button type="submit" className="btn-shimmer my-4">
                          Show Matches
                        </button>
                      </div>
                    </Form>
                  </div>

                  <p className="trustedText">
                    Trusted, Verified & Made for Veerashaiva Lingayat Community
                  </p>
                </div>
              </Col>
            </Row>
          </Container>

          <div style={{ background: "#6b1f2d" }}>
            <Container fluid="xxl" className="px-2 py-2">
              <Row className="text-white d-flex flex-wrap  justify-content-center pt-4 pb-3 g-3 text-center  align-items-center">
                <Col xs={6} md={3}>
                  <div className="feature-card">
                    <div className="feature-icon">
                      <FaShieldAlt />
                    </div>


                    <h6 className="mb-0 fw-semibold">ID Verified Profiles</h6>
                    <small style={{ opacity: 0.8 }}>
                      100% authentic profiles
                    </small>

                  </div>
                </Col>

                {/* Item 2 */}
                <Col xs={6} md={3}>
                  <div className="feature-card">
                    <div className="feature-icon">
                      <FaUsers />
                    </div>


                    <h6 className="mb-0 fw-semibold">Success Stories</h6>
                    <small style={{ opacity: 0.8 }}>
                      Thousands found their match
                    </small>

                  </div>
                </Col>

                {/* Item 3 */}
                <Col md={3} sm={6} xs={6}>
                  <div className="feature-card">
                    <div className="feature-icon">
                      <FaLock />
                    </div>

                    <h6 className="mb-0 fw-semibold">Safe & Private</h6>
                    <small style={{ opacity: 0.8 }}>
                      Your data is secure
                    </small>
                  </div>

                </Col>

                {/* Item 4 */}
                <Col md={3} sm={6} xs={6}>
                  <div className="feature-card">
                    <div className="feature-icon">
                      <FaStar />
                    </div>


                    <h6 className="mb-0 fw-semibold">Faster Match</h6>
                    <small style={{ opacity: 0.8 }}>
                      Smart recommendations
                    </small>

                  </div>
                </Col>
              </Row>
            </Container>
          </div>
        </div>

        {/* About  */}

        <div className="about-section mt-2">
          <Container fluid="xxl" className="py-4">
            <Row className="align-items-center">

              {/* LEFT CONTENT */}
              <Col xxl={5} xl={6} lg={7} md={8} className="about-left">



                <h2 className="about-title">
                  Welcome to KVL Matrimony
                </h2>

                <div className="about-highlight">
                  <div className="about-highlight-inner">
                    <p className="about-text">
                      Finding the right life partner is one of life’s most important decisions. KVL Matrimony is a trusted platform dedicated to helping members of the Karnataka Veerashaiva Lingayat community connect with compatible matches in a safe, secure and user-friendly environment. Create your profile today and begin your journey towards a happy and meaningful married life.
                    </p>
                  </div>
                </div>

                <Button
                  className="about-btn"
                  onClick={() => navigate("/register")}
                >
                  Create Your Profile
                </Button>

              </Col>

              {/* RIGHT IMAGE SECTION */}
              <Col lg={6} md={12} className="about-right">

                <img
                  src={aboutimg}
                  alt="couple"
                  className="about-img-main"
                />

                <img
                  src={bride2}
                  alt="bride"
                  className="about-img-overlay"
                />

              </Col>

            </Row>
          </Container>
        </div>

        <div className="my-1" style={{ background: "#fff", padding: "80px 0" }}>
          <Container fluid="xxl">

            <div style={{ textAlign: "center", marginBottom: "50px" }}>
              <h2 style={{ fontWeight: "700", color: "#6b1f2d" }}>
                Featured Matches
              </h2>

              <p style={{ color: "#666" }}>
                Discover verified profiles that match your preferences
              </p>
            </div>

            <Swiper
              modules={[Autoplay, FreeMode]}
              spaceBetween={30}
              loop={true}
              freeMode={true}
              speed={8000}
              autoplay={{
                delay: 0,
                disableOnInteraction: false,
              }}
              breakpoints={{
                320: { slidesPerView: 1 },
                576: { slidesPerView: 2 },
                768: { slidesPerView: 3 },
                1200: { slidesPerView: 4 },
                1600: { slidesPerView: 5 },
                1900: { slidesPerView: 6 },
                2500: { slidesPerView: 7 },
              }}
            >
              {profiles.map((profile) => (
                <SwiperSlide key={profile.id}>
                  <Card
                    style={{
                      borderRadius: "15px",

                      overflow: "hidden",
                      border: "1px solid #eee",
                      boxShadow: "0 5px 20px rgba(0,0,0,0.08)",
                    }}
                  >
                    <div style={{ position: "relative" }}>
                      <Card.Img
                        src={profile.image}
                        style={{
                          height: "220px",
                          filter: "blur(3px)",
                          objectFit: "cover",
                        }}
                      />

                      <span
                        style={{
                          position: "absolute",
                          top: "10px",
                          right: "10px",
                          background: "#1e88e5",
                          color: "#fff",
                          padding: "5px 12px",
                          borderRadius: "20px",
                          fontSize: "12px",
                          fontWeight: "500",
                        }}
                      >
                        ✔ Verified
                      </span>
                    </div>

                    {/* BODY */}
                    <Card.Body>
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          alignItems: "center",
                          marginBottom: "6px",
                        }}
                      >
                        <span
                          style={{
                            fontWeight: "600",
                            fontSize: "18px",
                            color: "#222",
                          }}
                        >
                          {profile.name}
                        </span>

                        <span
                          style={{
                            background: "#f3f3f3",
                            color: "#444",
                            fontSize: "13px",
                            padding: "4px 10px",
                            borderRadius: "20px",
                            fontWeight: "500",
                          }}
                        >
                          {profile.age} yrs
                        </span>
                      </div>

                      <p
                        style={{
                          marginTop: "8px",
                          marginBottom: "5px",
                          color: "#555",
                        }}
                      >
                        <BsGeoAlt size={14} /> {profile.location}
                      </p>

                      <p style={{ marginBottom: "3px", color: "#555" }}>
                        <GoMortarBoard size={14} /> {profile.education}
                      </p>

                      <p style={{ color: "#555" }}>{profile.job}</p>

                      <div style={{ display: "flex", gap: "10px" }}>
                        <Button
                          variant="outline-dark"
                          style={{
                            borderRadius: "25px",
                            width: "50%",
                            fontSize: "10px",
                          }}
                          onClick={() => navigate("/register")}
                        >
                          <MdOutlineRemoveRedEye size={16} /> View
                        </Button>

                        <Button
                          style={{
                            background: "#6b1f2d",
                            border: "none",
                            borderRadius: "25px",
                            width: "50%",
                            fontSize: "10px",
                          }}
                          onClick={() => navigate("/register")}
                        >
                          <IoMdHeartEmpty size={16} /> Interest
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </SwiperSlide>
              ))}
            </Swiper>
          </Container>
        </div>
        <div className="joinapp-section">
          <Container fluid="xxl">
            <Row className="align-items-center">
              <Col lg={6} md={12} className="joinapp-left">
                <p className="joinapp-subtitle">JOIN TODAY</p>

                <h2 className="joinapp-title">KVL Matrimony</h2>

                <p className="joinapp-text">
                  Find your perfect life partner from the comfort of your home. With our premium membership, you can connect with genuine, verified profiles through a platform that is simple, fast, convenient, safe and secure.
                </p>

                <p className="joinapp-text">
                  Thousands of happy marriages happened through our Matrimony.
                  <span className="joinapp-highlight">
                    {" "}Yours could be next...
                  </span>
                </p>
              </Col>

              <Col lg={6} md={12} className="joinapp-right">
                <div className="video-wrapper">
                  <iframe
                    className="joinapp-video"
                    src={`https://www.youtube.com/embed/RyfkowSnAjI?${isPlaying ? "autoplay=1" : ""
                      }&rel=0`}
                    title="YouTube Shorts"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  />

                  {!isPlaying && (
                    <>
                      <div className="video-overlay" />
                      <button
                        className="play-btn"
                        onClick={() => setIsPlaying(true)}
                      >
                        <FaPlay />
                      </button>
                    </>
                  )}
                </div>
              </Col>
            </Row>
          </Container>
        </div>
        <div className="success-section">
          <Container fluid="xxl">


            <div className="success-header">
              <p className="success-subtitle">SUCCESS STORIES</p>

              <h2 className="success-title">Happy Couples</h2>

              <p className="success-desc">
                Real stories of people who found love on KVL Matrimony
              </p>
            </div>

            <Swiper
              modules={[Autoplay]}
              autoplay={{
                delay: 5000,
                disableOnInteraction: false,
              }}
              loop={true}
            >
              {testimonials.map((item, i) => (
                <SwiperSlide key={i}>

                  <div className="success-card">


                    <div className="success-image-box">
                      <img
                        src={item.image}
                        alt="couple"
                        className="success-img"
                      />

                      <div className="success-badge">
                        <strong>{item.name}</strong>
                        <div className="success-place">{item.place}</div>
                      </div>
                    </div>


                    <div className="success-content">

                      <div className="success-quote">”</div>

                      <p className="success-text">
                        {item.text}
                      </p>



                    </div>

                  </div>

                </SwiperSlide>
              ))}
            </Swiper>

          </Container>
        </div>
        <Footer />
      </RouteLoader>
    </>
  );
}
